import moment from "moment";

const formatBreakdownPart = (value, singular, plural) => {
  if (value <= 0) {
    return null;
  }

  return `${value} ${value === 1 ? singular : plural}`;
};

const getLeaseTermParts = (start, end) => {
  let years = 0;
  let months = 0;
  let cursor = start.clone();

  while (cursor.clone().add(1, "year").isSameOrBefore(end)) {
    years += 1;
    cursor.add(1, "year");
  }

  while (cursor.clone().add(1, "month").isSameOrBefore(end)) {
    months += 1;
    cursor.add(1, "month");
  }

  const days = end.diff(cursor, "days");

  return {
    years,
    months,
    days,
    totalMonths: years * 12 + months,
  };
};

const formatBreakdown = (years, months, days) => {
  const parts = [
    formatBreakdownPart(years, "Year", "Years"),
    formatBreakdownPart(months, "Month", "Months"),
    formatBreakdownPart(days, "Day", "Days"),
  ].filter(Boolean);

  return parts.length > 0 ? parts.join(", ") : "0 Days";
};

export const formatLeaseTerm = (commenceDate, expireDate) => {
  if (!commenceDate || !expireDate) {
    return "-";
  }

  const start = moment.utc(commenceDate).startOf("day");
  const end = moment.utc(expireDate).startOf("day");

  if (!start.isValid() || !end.isValid() || end.isBefore(start)) {
    return "-";
  }

  const { years, months, days, totalMonths } = getLeaseTermParts(start, end);
  const monthLabel = totalMonths === 1 ? "month" : "months";
  const breakdown = formatBreakdown(years, months, days);

  return `${totalMonths} ${monthLabel} (${breakdown})`;
};
